import './tripFactorDetails.css';
import {useEffect, useState} from "react";
import Placeholder from "../../shared/placeholder/placeholder";

const userDetails = JSON.parse(localStorage.getItem("user-details"));

const TripFactorDetails = ({onAlertClick = (alert) => {}, alerts = [], loader = false}) => {
    const [expandAlerts, setExpandAlerts] = useState(false);
    const [selectedAlert, setSelectedAlert] = useState({});
    const [category, setCategory] = useState([]);
    const userAlerts = userDetails?.skuDetails?.alerts.map((alert) => {
        alert['count'] = 0;
        return alert;
    }) || [];
    const alertCounts = [];

    const updateAlerts = () => {
        if (alerts?.length > 0) {
            for (const alert of alerts) {
                const isAlertExist = alertCounts.find((countAlert) => alert.alertType === countAlert.alertString);
                if (isAlertExist)
                {
                    isAlertExist.count += 1;
                } else {
                    for (const userAlert of userAlerts) {
                        if (alert.alertType === userAlert.alertString) {
                            const newAlert = {...userAlert};
                            newAlert.count += 1;
                            alertCounts.push(newAlert);
                            break;
                        }
                    }
                }
            }
            // to add rest of the alerts which has no counts
            if (userAlerts.length !== alertCounts.length) {
                for (const userAlert of userAlerts) {
                    const isAlertExist = alertCounts.find((countAlert) => countAlert.alertString === userAlert.alertString);
                    if (!isAlertExist) alertCounts.push(userAlert);
                }
            }
            setCategory(alertCounts);
        }
    }

    const handleOnAlertClicked = (alert) => {
        if (alert.count > 0) {
            if (selectedAlert?.alertString === alert?.alertString) {
                setSelectedAlert({});
                onAlertClick('');
            } else {
                setSelectedAlert(alert);
                onAlertClick(alert?.alertString)
            }
        }
    }


    useEffect(() => {
        if (alerts.length > 0)  updateAlerts();
    }, [alerts])


    return (
        <>
            <div className={`trip-factors-box margin-b-10 ${expandAlerts ? 'expand' : ''}`}>
                {loader &&
                    <ul className={'grid hr-space-between col-4 gap-15'}>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((placeholder) =>
                            <li key={placeholder}><Placeholder height={'70px'} width={'70px'} round={'8px'}/></li>
                        )}

                    </ul>
                }
                {!loader &&
                    <ul className={'trip-factors page-fade-in sf-medium grid hr-space-between col-4'}>
                        {(category).map((cat) =>
                            <li key={cat.alertString}
                                className={((cat?.count > 0 && !selectedAlert?.alertString) ||
                                    (selectedAlert?.alertString === cat?.alertString)) ? cat.type : 'disabled' }
                                onClick={(event) => handleOnAlertClicked(cat)}>
                                <div className="number">
                                    {cat?.count < 10 ? `0${cat?.count}` : cat?.count}
                                </div>
                                <div className="name">{cat?.type.slice(0, 3)}</div>
                                <div className='tooltip'>{cat?.displayString}</div>
                            </li>
                        )}
                    </ul>
                }
            </div>
            {/*<div className="flex hr-right sf-medium highlight-color">*/}
            {/*    {*/}
            {/*        !expandAlerts &&*/}
            {/*        <div className="font-14 cursor-pointer padding-l-5"*/}
            {/*             onClick={event => setExpandAlerts(true)}>More</div>*/}
            {/*    }*/}
            {/*    {*/}
            {/*        expandAlerts &&*/}
            {/*        <div className="font-14 cursor-pointer padding-l-5"*/}
            {/*             onClick={event => setExpandAlerts(false)}>Less</div>*/}
            {/*    }*/}
            {/*</div>*/}
        </>
    )
}

export default TripFactorDetails;
